import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '49px 0 43px',
    display: 'flex',
    position: 'relative',
    zIndex: 10,
    background: 'rgb(248, 249, 250)',
    color: 'rgb(60, 64, 67)',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  image: {
    marginLeft: 30,
    width: 86,
  },
  anchor: {
    display: 'flex',
    alignSelf: 'flex-end',
    fontFamily: 'Roboto, sans-serif',
    color: 'rgb(95, 99, 104)',
    marginRight: 28,
    textDecoration: 'none',
    transition: 'color 0.2s ease-in-out 0s',
    background: 'transparent',
    paddingBottom: '2px',
    whiteSpace: 'nowrap',
    marginTop: 20,
    marginBottom: 14,
    [theme.breakpoints.down('md')]: {
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0.28px',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '14px',
      lineHeight: '22px',
      letterSpacing: '0.25px',
    },
  },
  links: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      marginTop: 10,
      marginLeft: 50,
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
}));

export const Footer = () => {
  const { root, image, anchor, links } = useStyles();
  return (
    <footer className={root}>
      <img
        src="https://inthecloud.withgoogle.com/future-of-work-21/workspace-quiz-footer-logo.svg"
        alt="Google"
        style={{ margin: '0 28px 0 50px' }}
        className={image}
      />
      <div className={links}>
        <a className={anchor} href="https://about.google/" target="blank">
          About Google
        </a>
        <a
          className={anchor}
          href="https://about.google/products/?tip=explore"
          target="blank"
        >
          Google Products
        </a>
        <a
          className={anchor}
          href="https://policies.google.com/privacy"
          target="blank"
        >
          Privacy
        </a>
        <a
          className={anchor}
          href="https://policies.google.com/terms?hl=en"
          target="blank"
        >
          Terms
        </a>
      </div>
    </footer>
  );
};
